import type { ReactElement } from 'react';

import { Icon, StyledIconButton } from './GoToTop.styled';

interface GoToTopProps {
  isVisible?: boolean;
}

export const GoToTop = ({ isVisible = true }: GoToTopProps): ReactElement => (
  <StyledIconButton
    onClick={() =>
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }
    ariaLabel="Wróć na górę strony"
    isVisible={isVisible}
  >
    <Icon />
  </StyledIconButton>
);
